<template>
  <div
    v-show="visible"
    class="context-menu el-select-dropdown__wrap"
    :style="style"
  >
    <slot name="menu"></slot>
  </div>
</template>

<script>
export default {
  name: 'ContextMenu',
  data() {
    return {
      visible: false,
      x: 0,
      y: 0
    }
  },
  computed: {
    style() {
      return `left:${this.x}px;top:${this.y}px;`
    }
  },
  methods: {
    close() {
      this.visible = false
      window.removeEventListener('keyup', this.keyListener)
      this.$nextTick(function() {
        if (typeof this.onClose === 'function') {
          this.onClose()
        }
        this.x = 0
        this.y = 0
      })
    },
    keyListener() {
      this.$emit('close')
    },
    showContextMenu(e) {
      this.x = e.offsetX + e.target.offsetLeft + 10
      this.y = e.offsetY + e.target.offsetTop + 10
      this.visible = true
    }
  },
  watch: {
    visible(v) {
      if (v) {
        window.addEventListener('click', this.keyListener)
      } else {
        window.removeEventListener('click', this.keyListener)
      }
    }
  }
}
</script>

<style lang="scss">
// .context-menu-wrap {
//   height: 100%;
//   box-sizing: border-box;
//   z-index: 999;
//   position: absolute;
// }
.context-menu {
  position: absolute;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
}
</style>
